import { gql } from '@apollo/client';

export const postCuentasFAL = gql`
mutation CuentasFALApiRQ{
    CuentasFALApiRQ(input: $input)  
        @rest(type: "CuentasFALSPApiRS", path: "/api/gateway/formularios/FormularioFAL", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`